/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgeReportTotals
 */
export interface AgeReportTotals {
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _lt_18: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _18_20: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _21_24: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _25_29: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _30_39: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _40_49: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _50_59: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    _gte_60: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    average_age: number;
    /**
     * 
     * @type {number}
     * @memberof AgeReportTotals
     */
    median_age: number;
    /**
     * 
     * @type {Date}
     * @memberof AgeReportTotals
     */
    first_redemption: Date | null;
}

/**
 * Check if a given object implements the AgeReportTotals interface.
 */
export function instanceOfAgeReportTotals(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "_lt_18" in value;
    isInstance = isInstance && "_18_20" in value;
    isInstance = isInstance && "_21_24" in value;
    isInstance = isInstance && "_25_29" in value;
    isInstance = isInstance && "_30_39" in value;
    isInstance = isInstance && "_40_49" in value;
    isInstance = isInstance && "_50_59" in value;
    isInstance = isInstance && "_gte_60" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "average_age" in value;
    isInstance = isInstance && "median_age" in value;
    isInstance = isInstance && "first_redemption" in value;

    return isInstance;
}

export function AgeReportTotalsFromJSON(json: any): AgeReportTotals {
    return AgeReportTotalsFromJSONTyped(json, false);
}

export function AgeReportTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgeReportTotals {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '_lt_18': json['_lt_18'],
        '_18_20': json['_18_20'],
        '_21_24': json['_21_24'],
        '_25_29': json['_25_29'],
        '_30_39': json['_30_39'],
        '_40_49': json['_40_49'],
        '_50_59': json['_50_59'],
        '_gte_60': json['_gte_60'],
        'total': json['total'],
        'average_age': json['average_age'],
        'median_age': json['median_age'],
        'first_redemption': (json['first_redemption'] === null ? null : new Date(json['first_redemption'])),
    };
}

export function AgeReportTotalsToJSON(value?: AgeReportTotals | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '_lt_18': value._lt_18,
        '_18_20': value._18_20,
        '_21_24': value._21_24,
        '_25_29': value._25_29,
        '_30_39': value._30_39,
        '_40_49': value._40_49,
        '_50_59': value._50_59,
        '_gte_60': value._gte_60,
        'total': value.total,
        'average_age': value.average_age,
        'median_age': value.median_age,
        'first_redemption': (value.first_redemption === null ? null : value.first_redemption.toISOString()),
    };
}

